import BSN from "bootstrap.native"
import Tabulator from "tabulator-tables";
import AutoNumeric from 'autonumeric';
import { ApplicationController } from "../application_controller";

Tabulator.prototype.extendModule("columnCalcs", "calculations", {
  "wagesPaymentsTotalText": function (values, data, calcParams) {
    const table = document.getElementById("wages_payments_table")
    if (table)
      return table.getAttribute("data-total-text")
  },
  "wagesPaymentsTotalAmount": function (values, data, calcParams) {
    const table = document.getElementById("wages_payments_table")
    if (!table) return 0;
    let total_html = table.getAttribute("data-total-amount");
    return total_html;
  },
  "wagesPaymentsTotalPaid": function (values, data, calcParams) {
    const table = document.getElementById("wages_payments_table")
    if (!table) return 0;
    let total_html = table.getAttribute("data-total-paid");
    return total_html;
  },
  "wagesPaymentsTotalBalance": function (values, data, calcParams) {
    const table = document.getElementById("wages_payments_table")
    if (!table) return 0;
    let total_html = table.getAttribute("data-total-balance");
    return total_html;
  }
});


export default class extends ApplicationController {
  static targets = [ "sidebar_table", "index_table",
    "search", "department_ids",
    "transaction_currency_radio_template", "modal_currencies_radio",
    "modal_currency_text",
    "to_main_rate_field", "from_main_rate_field",
    "to_additional_rate_field", "from_additional_rate_field",
    "current_balance_info", "current_balance_display", "validation_message"
  ]

  connect() {
    this.currentCurrency = null;
    this.availableBalances = null;
    
    if (this.hasSidebar_tableTarget) {
      const content_url = this.sidebar_tableTarget.getAttribute("data-table-load-url");
      this.createSidebarTable(content_url);
    }

    if (this.hasIndex_tableTarget) {
      const content_url = this.index_tableTarget.getAttribute("data-table-load-url");
      this.createIndexTable(content_url);
    }

    // Load current balance for expense forms
    if (this.hasCurrent_balance_displayTarget) {
      this.loadCurrentBalance();
    }

    // Load dynamic exchange rates on initial load
    const selectedCurrency = this.getSelectedCurrency();
    if (selectedCurrency) {
      this.currentCurrency = selectedCurrency;
      this.loadDynamicExchangeRates(selectedCurrency);
    }
  }

  onPostPutSuccess(event) {
    const [data, status, xhr] = event.detail;
    if (data) {
      // show notify
      window.vNotify.success({ text: data.notification_message, title: data.notification_title });

      const rowId = data.id;
      const rowData = data.data;

      // update table data
      this.updateTable(rowId, rowData, { total_paid:    data.total_paid,
                                         total_balance: data.total_balance });

      window.layout_modal_md.hide();
    }
  }

  onPostPutError(event) {
    const [data, status, xhr] = event.detail;
    window.layout_modal_md.setContent(data.form_content)
  }

  openModal(event) {
    event.preventDefault();
    let url = event.currentTarget.getAttribute("data-url");

    let filters = []
    if (this.hasSearchTarget && this.searchTarget.value != '') {
      filters.push("q=" + this.searchTarget.value);
    }
    if (this.hasDepartment_idsTarget && this.department_idsTarget.choices.getValue(true) != '') {
      filters.push("department_ids=" + this.department_idsTarget.choices.getValue(true));
    }
    filters = filters.join("&")
    if (filters.length) {
      url += (url.search(/\?/) > 0 ? "&" : "?") + filters
    }

    this.openLayoutModalMD(url);
  }

  // Load available balances for all currencies
  async loadCurrentBalance() {
    try {
      const response = await fetch('/cashbox/wages_payments/available_balances', {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (response.ok) {
        this.availableBalances = await response.json();
        const selectedCurrency = this.getSelectedCurrency();
        if (selectedCurrency) {
          this.displayCurrentBalance(selectedCurrency);
        }
      } else {
        console.error('Failed to load available balances');
      }
    } catch (error) {
      console.error('Error loading balances:', error);
    }
  }

  // Display balance for selected currency
  displayCurrentBalance(currency) {
    if (!this.availableBalances || !this.hasCurrent_balance_displayTarget) return;

    const currencyBalance = this.availableBalances.find(b => b.currency === currency);
    
    if (currencyBalance) {
      const balanceValue = parseFloat(currencyBalance.balance_cents) / 100;
      const balanceClass = balanceValue > 0 ? 'text-success' : 'text-danger';
      
      const balanceHTML = `
        <span class="${balanceClass}">${currencyBalance.balance_formatted}</span>
      `;
      this.current_balance_displayTarget.innerHTML = balanceHTML;
    } else {
      this.current_balance_displayTarget.innerHTML = `<span class="text-muted">${currency}: 0</span>`;
    }
  }

  // Get currently selected currency
  getSelectedCurrency() {
    const checkedRadio = document.querySelector('input[name="cashbox_transaction[amount_currency]"]:checked');
    return checkedRadio ? checkedRadio.value : null;
  }

  // Get numeric value from amount field
  getAmountValue() {
    const amountField = document.querySelector('input[name="cashbox_transaction[amount]"]');
    if (!amountField) return 0;

    let value = amountField.value;
    
    // If IMask is applied, try to get the unmasked value
    if (amountField.inputmask && amountField.inputmask.unmaskedvalue) {
      value = amountField.inputmask.unmaskedvalue();
    }
    
    // Clean up: remove spaces and convert comma to dot
    value = value.toString().replace(/\s/g, '').replace(',', '.');
    
    return parseFloat(value) || 0;
  }

  // Validate expense amount
  async validateExpenseAmount(event) {
    const amount = this.getAmountValue();
    const currency = this.getSelectedCurrency();

    if (!currency || amount <= 0) {
      this.hideValidationMessage();
      return;
    }

    try {
      const response = await fetch('/cashbox/wages_payments/validate_expense', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content,
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ amount: amount, currency: currency })
      });

      const data = await response.json();

      if (!data.valid) {
        // Format amounts (cents to currency units)
        const availableFormatted = `${(data.available_balance / 100).toFixed(2)} ${data.currency}`;
        const requiredFormatted = `${(data.required_amount / 100).toFixed(2)} ${data.currency}`;
        
        const message = this.validation_messageTarget.getAttribute('data-insufficient-funds')
          .replace('%{currency}', data.currency)
          .replace('%{available}', availableFormatted)
          .replace('%{required}', requiredFormatted);
        
        this.showValidationMessage(message, 'danger');
      } else {
        this.hideValidationMessage();
      }

      // Update dynamic exchange rates based on amount
      this.loadDynamicExchangeRates(currency, amount);
    } catch (error) {
      console.error('Error validating expense:', error);
    }
  }

  // Show validation message
  showValidationMessage(message, type) {
    if (this.hasValidation_messageTarget) {
      this.validation_messageTarget.innerHTML = `
        <div class="alert alert-${type} mb-0 py-2">
          <small>${message}</small>
        </div>
      `;
      this.validation_messageTarget.style.display = 'block';
    }
  }

  // Hide validation message
  hideValidationMessage() {
    if (this.hasValidation_messageTarget) {
      this.validation_messageTarget.style.display = 'none';
    }
  }

  // Load dynamic exchange rates from API
  async loadDynamicExchangeRates(currency, amount = null) {
    if (!currency) return;
    
    try {
      const currentAmount = amount || this.getAmountValue();
      const params = new URLSearchParams({
        currency: currency,
        amount: currentAmount
      });
      
      const response = await fetch(`/cashbox/wages_payments/expense_exchange_rates?${params}`, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });
      
      if (response.ok) {
        const rates = await response.json();
        if (rates.error) {
          console.error('Exchange rates error:', rates.error);
          // Use default rates if available
          if (rates.default_rates) {
            this.updateExchangeRateFields(rates.default_rates);
          }
        } else {
          this.updateExchangeRateFields(rates);
        }
      } else {
        console.error('Failed to load dynamic exchange rates:', response.statusText);
      }
    } catch (error) {
      console.error('Error loading dynamic exchange rates:', error);
    }
  }

  // Update exchange rate input fields and displays
  updateExchangeRateFields(rates) {
    // Update hidden rate fields
    const fromMainInput = document.querySelector('input[name="cashbox_transaction[from_main_rate]"]');
    const toAdditionalInput = document.querySelector('input[name="cashbox_transaction[to_additional_rate]"]');
    
    if (fromMainInput) {
      fromMainInput.value = rates.from_main_rate || 1.0;
    }
    if (toAdditionalInput) {
      toAdditionalInput.value = rates.to_additional_rate || 1.0;
    }

    // Update display fields
    if (this.hasFrom_main_rate_fieldTarget && rates.from_main_display) {
      const displaySpan = this.from_main_rate_fieldTarget.querySelector('.exchange-rate-display span');
      if (displaySpan) {
        displaySpan.innerHTML = rates.from_main_display;
      }
    }

    if (this.hasTo_additional_rate_fieldTarget && rates.to_additional_display) {
      const displaySpan = this.to_additional_rate_fieldTarget.querySelector('.exchange-rate-display span');
      if (displaySpan) {
        displaySpan.innerHTML = rates.to_additional_display;
      }
    }

    // Show/hide rate fields based on currency
    if (rates.is_main) {
      if (this.hasFrom_main_rate_fieldTarget) this.from_main_rate_fieldTarget.classList.add('hidden');
      if (this.hasTo_main_rate_fieldTarget) this.to_main_rate_fieldTarget.classList.add('hidden');
    } else {
      if (this.hasFrom_main_rate_fieldTarget) this.from_main_rate_fieldTarget.classList.remove('hidden');
      if (this.hasTo_main_rate_fieldTarget) this.to_main_rate_fieldTarget.classList.remove('hidden');
    }

    if (rates.is_additional) {
      if (this.hasFrom_additional_rate_fieldTarget) this.from_additional_rate_fieldTarget.classList.add('hidden');
      if (this.hasTo_additional_rate_fieldTarget) this.to_additional_rate_fieldTarget.classList.add('hidden');
    } else {
      if (this.hasFrom_additional_rate_fieldTarget) this.from_additional_rate_fieldTarget.classList.remove('hidden');
      if (this.hasTo_additional_rate_fieldTarget) this.to_additional_rate_fieldTarget.classList.remove('hidden');
    }
  }


  updateTransactionCurrencies(event) {
    let currencies = event.currentTarget.getAttribute("data-account-currencies");
    let li_template = this.transaction_currency_radio_templateTarget.innerHTML;
    let currencies_ul = this.modal_currencies_radioTarget;

    currencies_ul.innerHTML = "";
    if (currencies) {
      JSON.parse(currencies).forEach(el => {
        let li = document.createElement("li");
        let currency_class = (el["disabled"] == true ? "disabled" : "")
        let li_html = li_template.replace(/TRANSACTION_AMOUNT_CURRENCY_CODE/g, el["currency"]);
        li_html = li_html.replace(/TRANSACTION_AMOUNT_CURRENCY_CLASS/g, currency_class);
        li_html = li_html.replace(/\"TRANSACTION_CURRENCY_INFO\"/g, JSON.stringify(el));

        li.classList.add("nav-item");
        li.innerHTML = li_html;
        currencies_ul.appendChild(li);
      });

      let currency = currencies_ul.querySelector("li:first-child input[type=radio]");
      currency.checked = true;

      this.updateTransactionInputCurrencies(currency);
    }
  }

  updateCurrencyFields(event) {
    const currency = event.currentTarget;
    const selectedCurrency = currency.getAttribute("value");
    
    if (this.currentCurrency === selectedCurrency) {
      return; // No change, skip API calls
    }
    
    this.currentCurrency = selectedCurrency;
    
    this.updateTransactionInputCurrencies(currency);
    
    // Update current balance for the new currency
    if (this.hasCurrent_balance_displayTarget) {
      if (this.availableBalances) {
        this.displayCurrentBalance(selectedCurrency);
      } else {
        this.loadCurrentBalance();
      }
    }
    
    // Load dynamic exchange rates
    this.loadDynamicExchangeRates(selectedCurrency);
    
    // Re-validate amount if there's a value
    const amountField = document.querySelector('input[name="cashbox_transaction[amount]"]');
    if (amountField && this.getAmountValue() > 0) {
      this.validateExpenseAmount({ target: amountField });
    }
  }

  updateTransactionInputCurrencies(element) {
    let currency = element.getAttribute("value");
    this.modal_currency_textTarget.innerHTML = currency;
  }



  filterTable() {
    this.setFilterToTable();
  }

  setFilterToTable() {
    let table = this.index_tableTarget.tabulator;
    let filters = [];

    if (this.hasSearchTarget) {
      filters.push({
        field: "q",
        type: "=",
        value: this.searchTarget.value
      })
    }

    if (this.hasDepartment_idsTarget) {
      filters.push({
        field: "department_ids",
        type: "=",
        value: this.department_idsTarget.choices.getValue(true)
      })
    }

    if (filters.length) {
      table.setFilter(filters);
    }
  }

  async updateTable(rowId, rowData, totals) {
    const mainTable = document.getElementById("wages_payments_table");
    const mainTabulator = mainTable.tabulator;

    mainTable.setAttribute("data-total-paid", totals["total_paid"]);
    mainTable.setAttribute("data-total-balance", totals["total_balance"]);

    mainTabulator.updateRow(rowId, rowData);
  }


  async createIndexTable(url) {
    const table_target = this.index_tableTarget;
    const columns = table_target.getAttribute("data-table-columns");
    const default_props = super.tabulatorDefaultProps;
    const height = document.getElementById('content').clientHeight;
    const sort_column = table_target.getAttribute("data-sort-column");
    const sort_dir = table_target.getAttribute("data-sort-dir");

    let table_props = {
      persistenceID: "wages_payments_table",
      layout: "fitDataTable",
      virtualDomBuffer: 4000,
      index: "id",
      height: (height - 150) + "px",
      movableColumns: true,
      initialSort: [
        { column: sort_column, dir: sort_dir }
      ],
      // columns
      columns: JSON.parse(columns),
      // pagination
      paginationDataSent: {
        "size": "per_page"
      },
      paginationSize: 25,
      paginationSizeSelector: [10, 25, 50],
      pagination: "remote",
      // Ajax
      ajaxURL: url,
      ajaxSorting: true,
      ajaxFiltering: true,
      ajaxLoader: true,
      ajaxLoaderLoading: "<div class='loader' > Loading...</div> ",

      ajaxResponse:function(url, params, response){
        const table = document.getElementById("wages_payments_table")
        table.setAttribute("data-total-amount", response.total_amount);
        table.setAttribute("data-total-paid", response.total_paid);
        table.setAttribute("data-total-balance", response.total_balance);

        return response;
      }
    }

    table_props = Object.assign(default_props, table_props);
    // create table
    table_target.tabulator = new Tabulator(table_target, table_props);
    table_target.tabulator.setLocale(super.appLocale);
  }


  // create sidebar
  async createSidebarTable(url) {
    const table_target = this.sidebar_tableTarget;
    const columns = table_target.getAttribute("data-table-columns");
    const per_page = table_target.getAttribute("data-per-page");

    //
    let loadSelected = this.createContent
    let puthToTurbolinks = this.historyPush

    let table_props = {
      persistenceID: "wages_payments_sidebar_table",
      layout: "fitDataStretch",
      headerSort: false,
      headerVisible: false,
      height: "100%",
      // columns
      columns: JSON.parse(columns),
      // pagination
      paginationDataSent: {
        "size": "per_page"
      },
      paginationSize: 100,
      // Ajax
      ajaxURL: url,
      ajaxSorting: true,
      ajaxFiltering: true,
      ajaxProgressiveLoad: "scroll",
      //
      rowFormatter: function (row) {
        //row - row component
        const data = row.getData();
        if (data.url) row.getElement().dataset.url = data.url;
        if (data.history_url) row.getElement().dataset.history_url = data.history_url;

        if (data.is_selected) {
          row.select();
        }
      },
      rowClick: function (e, row) {
        const content_url = row.getElement().dataset.url;
        const history_url = row.getElement().dataset.history_url;
        loadSelected(content_url);
        let row_table = row.getTable();
        row_table.deselectRow();
        row.select();
        puthToTurbolinks(history_url);
      }

    }
    // table props
    const default_props = super.tabulatorDefaultProps
    table_props = Object.assign(default_props, table_props);
    // create table
    table_target.tabulator = new Tabulator(table_target, table_props);
    table_target.tabulator.setLocale(super.appLocale);
  }

  async createContent(content_url) {
    const content_target = document.getElementById("content");
    let content_response = await fetch(content_url);
    let content = await content_response.text();
    content_target.innerHTML = content;
    super.updateSidebarStick();
  }


}